"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = require("../../../utils/Utils");
var CLEARINGNUMBER_REGEXP = /^\d{4}(\d|[-\s]?\d)?$/;
/**
 * parse clearing number to remove the 5th number.
 * Run before submitting form
 *  */
function parse(value) {
    return CLEARINGNUMBER_REGEXP.test(value) ? value.substring(0, 4) : value;
}
exports.parse = parse;
exports.clearingNumberValidator = {
    name: 'clearingNumber',
    validation: function (value) {
        return Utils_1.isEmpty(value) || CLEARINGNUMBER_REGEXP.test(value);
    },
    formatter: function (value) {
        /**
         * Formats the view value to the users. Adds hyphen between numbers 4 & 5
         * */
        if (CLEARINGNUMBER_REGEXP.test(value) && value.length === 5) {
            value = value.substring(0, 4) + '-' + value.substring(4, 5);
            return value;
        }
        return value;
    },
};
//# sourceMappingURL=ClearingNumberValidator.js.map